// extracted by mini-css-extract-plugin
export var active = "_jx-2";
export var recordingDot = "_jx-1";
export var recordingIndicator = "_jx-0";